import React from 'react';

import { MediaClientProvider } from '@atlaskit/media-client-react';

import { useMediaAuth } from 'src/hooks/media';
import { useParams } from 'src/router/hooks';

export const MediaClientConfigProvider = ({ children }: any) => {
  const { repositoryOwner, repositorySlug } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
  }>();

  const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;

  const mediaAuth = useMediaAuth({
    repositoryFullSlug,
  });

  return (
    <MediaClientProvider clientConfig={mediaAuth.mediaClientConfig!}>
      {children}
    </MediaClientProvider>
  );
};
